/**
 * Step — RIP routing map (Phase 65 / BLU-594 PR4). Embeds the bare
 * RipRoutingSection, which carries its own "needs attention" gap panel driven
 * by getRipRoutingCoverage. That coverage scan only fires when the section
 * mounts, and the page mounts only the selected, unlocked step, so the scan stays
 * lazy (never runs while the step is locked).
 */
import { useTranslation } from 'react-i18next';
import { RipRoutingSection } from '@/features/production-settings/components/RipRoutingSection';
import { StepPane } from '../shell/StepPane';

interface Step5Props {
  productTypes: number;
}

export function Step5RipRouting({ productTypes }: Step5Props) {
  const { t } = useTranslation('onboarding');
  return (
    <StepPane
      title={t('step5.title')}
      description={t('step5.description')}
      summary={t('step5.summary', { count: productTypes })}
    >
      <div className="rounded-lg border p-4">
        <RipRoutingSection />
      </div>
    </StepPane>
  );
}
